export const BREATH_CATS = ['breathwork', 'breathing'];

export const isBreathing = (a) => !!a && (BREATH_CATS.includes(String(a.category || '').trim().toLowerCase()) || !!a.breathing?.phases?.length);

export const hasGuidedTimer = (a) => !!a?.breathing?.enabled && (a.breathing.phases || []).length > 0;

export const defaultMinutes = (a) => (a?.metric_type !== 'steps' && a?.target_value) || a?.duration_min || 5;

export const norm = (s) => String(s || '').toLowerCase().replace(/[^a-z]/g, '');

export const sectionId = (s) => `sec-${norm(s)}`;

export const headingMatches = (headingText, section) => !!norm(section) && norm(headingText).includes(norm(section));

export const patternText = (phases = []) => phases.map(p => `${p.label || p.type} ${+p.seconds}s`).join(' · ');

export const learnMoreUrl = (a) => `/app/academy?article=${a.breathing.academy_article_id}&section=${encodeURIComponent(a.breathing.academy_section || '')}`;

export const fmtClock = (sec) => {
  const s = Math.max(0, Math.round(sec));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
};

export const SAFETY_TEXT = 'Breathe gently and comfortably. Do not force your breathing or hold your breath beyond what feels comfortable. Stop if you experience dizziness, breathlessness or discomfort.';
